"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropzone = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_dropzone_1 = require("react-dropzone");
var storm_ui_1 = require("@amzn/storm-ui");
var getColor = function (props) {
    if (props.isDragAccept) {
        return '#00e676';
    }
    if (props.isDragReject) {
        return '#ff1744';
    }
    if (props.isDragActive) {
        return '#2196f3';
    }
    return '#eeeeee';
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  border-width: 2px;\n  border-radius: 2px;\n  border-color: ", ";\n  border-style: dashed;\n  background-color: #fafafa;\n  color: #bdbdbd;\n  outline: none;\n  transition: border 0.24s ease-in-out;\n  margin-inline-end: ", ";\n  flex-grow: 1;\n  flex-basis: 0;\n  height: 200px;\n  width: 200px;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  border-width: 2px;\n  border-radius: 2px;\n  border-color: ", ";\n  border-style: dashed;\n  background-color: #fafafa;\n  color: #bdbdbd;\n  outline: none;\n  transition: border 0.24s ease-in-out;\n  margin-inline-end: ", ";\n  flex-grow: 1;\n  flex-basis: 0;\n  height: 200px;\n  width: 200px;\n"])), function (props) { return getColor(props); }, function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
});
var Centered = styled_components_1.default.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: none;\n  margin: auto;\n  text-align: center;\n"], ["\n  flex: none;\n  margin: auto;\n  text-align: center;\n"])));
var thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
};
var thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    width: 200,
    height: 200,
    boxSizing: 'border-box',
    margin: -22,
};
var thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
};
var img = {
    display: 'block',
    width: 'auto',
    height: '100%',
};
var StyledDropzone = function (props) {
    var logo = props.logo, onDropCallBack = props.onDropCallBack;
    var _a = (0, react_dropzone_1.useDropzone)({
        accept: 'image/*',
        onDrop: onDropCallBack,
    }), getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, isDragActive = _a.isDragActive, isDragAccept = _a.isDragAccept, isDragReject = _a.isDragReject;
    var thumbs = logo.map(function (logoFile) { return (react_1.default.createElement("div", { style: thumb, key: logoFile.name },
        react_1.default.createElement("div", { style: thumbInner },
            react_1.default.createElement("img", { alt: 'logo', src: logoFile.preview, style: img })))); });
    var icon = logo[0] ? null : (react_1.default.createElement(Centered, null,
        react_1.default.createElement(storm_ui_1.Icon, { type: "plus", size: "2x" }),
        react_1.default.createElement("br", null),
        "Upload Logo"));
    return (react_1.default.createElement(Container, __assign({}, getRootProps({ isDragActive: isDragActive, isDragAccept: isDragAccept, isDragReject: isDragReject })),
        react_1.default.createElement("input", __assign({}, getInputProps())),
        react_1.default.createElement("aside", { style: thumbsContainer }, thumbs),
        icon));
};
exports.StyledDropzone = StyledDropzone;
var templateObject_1, templateObject_2;
